import { CrudForm } from '../shared/CrudPage';
import { featureService } from '@kss/api';
import type { Feature, FeatureCreate, FeatureFilter } from '@kss/api';

/**
 * Feature form — wired to the live schema verified 2026-05-05.
 * Live row: `{ code, name, module, description }`. There is no
 * `category` (legacy) and no `isActive` (Features are global, not
 * tenant-toggleable). The strict-mode binder rejects both with
 * `UNKNOWN_FIELD` on save.
 */
type F = { code: string; name: string; module: string; description: string };
const empty: F = { code: '', name: '', module: '', description: '' };

export default function NewFeature() {
  return (
    <CrudForm<Feature, FeatureCreate, FeatureFilter, F>
      title="feature" service={featureService} idKey="featureId" basePath="/panel/features" emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code', placeholder: 'inventory.transfer' },
        { key: 'name', label: 'Name', required: true, placeholder: 'Inventory transfers' },
        { key: 'module', label: 'Module', placeholder: 'Inventory' },
        { key: 'description', label: 'Description', type: 'textarea', fullWidth: true },
      ]}
      fromEntity={(r) => ({
        code: r.code ?? '',
        name: r.name ?? '',
        // Older rows used `category`; live API uses `module`.
        module: (r as { module?: string }).module ?? r.category ?? '',
        description: r.description ?? '',
      })}
      toEntity={(f, id) => ({
        featureId: id,
        code: f.code || undefined,
        name: f.name,
        module: f.module || undefined,
        description: f.description || undefined,
      })}
      validate={(f) => !f.name.trim() ? 'Name is required' : null}
    />
  );
}
